export const drawRect = (detections, ctx) => {
  detections.forEach((prediction) => {
    // Get prediction results

    const [x, y, width, height] = prediction["bbox"];
    const text = prediction["class"];

    //Set style properties


    const color = 'red'
    ctx.strokeSylt = color
    ctx.font = '22px Arial'
    ctx.fillStyle = color

    // Draw Rectangle and Text

    ctx.beginPath();
    ctx.fillText(text,x,y);
    ctx.rect(x,y,width,height);
    ctx.stroke()
  });
};
